import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * V2 styled input component for authentication forms
 */
export default function V2AuthInput({
  type = "text",
  value,
  onChange,
  placeholder,
  error,
  disabled,
  className = "",
  ...props
}) {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === "password";
  const inputType = isPassword ? (showPassword ? "text" : "password") : type;

  return (
    <div className={`relative ${className}`}>
      <input
        type={inputType}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        className={`
          w-full rounded-[10px] border px-4 py-3 text-sm text-[#111827] placeholder-[#9CA3AF]
          outline-none transition-all duration-150
          ${error ? "border-red-400" : "border-[#E5E7EB]"}
          ${disabled ? "cursor-not-allowed bg-[#F3F4F6]" : "bg-white"}
          focus:border-[#E07A3A] focus:shadow-[0_0_0_3px_rgba(224,122,58,0.1)]
        `}
        {...props}
      />
      {isPassword && (
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-[#9CA3AF] transition-colors hover:text-[#6B7280]"
          tabIndex={-1}
        >
          {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
        </button>
      )}
    </div>
  );
}
